import ApiOTPProvider from './ApiOTPProvider';
import CallbackOTPProvider from './CallbackOTPProvider';
import { showLoader } from '../../shares/lib/otpUtils';
import { OTPConfig } from '../../shares/model/config';

// Define an interface for game OTP configuration
// interface GameOTPConfig {
//   remoteApiEnable: boolean;
//   [key: string]: any; // Allow additional properties if needed
// }

class OTPService {
  private otpProvider: ApiOTPProvider | CallbackOTPProvider;

  constructor(gameOTPConfig: OTPConfig) {
    this.otpProvider = gameOTPConfig.remoteApiEnable
      ? new ApiOTPProvider(gameOTPConfig)
      : new CallbackOTPProvider(gameOTPConfig);
  }

  async getOTP(gameId?: string): Promise<string | void> {
    showLoader();
    return await this.otpProvider.getOTP(gameId);
  }
}

export default OTPService;
